import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as propertyActions from '../../../actions/properties';
import DeleteModal from '../DeleteModal';

const propTypes = {
  data: PropTypes.object.isRequired,
  deleteProperty: PropTypes.func.isRequired
};

const DeleteHotelModal = ({ data, deleteProperty, ...props }) => (
  <DeleteModal
    id="delete-hotel-modal"
    title="Hotel"
    itemTitle={data.title}
    deleteItem={() => deleteProperty(data.id)}
    {...props}
  />
);

DeleteHotelModal.propTypes = propTypes;

export default connect(
  null,
  propertyActions
)(DeleteHotelModal);
